<template>
  <a-modal
    width="900px"
    :visible="visible"
    :title="loading && payType === 2 ? '微信支付中...' : '购买会员'"
    @cancel="handleCancel"
    :maskClosable="false"
    :closable="!(loading && payType === 2)"
    :footer="null"
  >
    <div class="buy-member-modal-container">
      <a-row :gutter="16">
        <!-- 左侧：会员信息和等级 -->
        <a-col :span="12">
          <!-- 会员信息 -->
          <a-card
            :bordered="false"
            title="会员信息"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '36px', 'border-bottom': '1px solid #DDD', 'line-height': '36px', 'padding-left': '12px' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
            style="margin-bottom: 12px"
          >
            <table class="info-table">
              <tr>
                <td class="label">会员姓名：</td>
                <td class="value">{{ memberData?.nickName || memberData?.realName || '-' }}</td>
              </tr>
              <tr>
                <td class="label">手机号：</td>
                <td class="value">{{ memberData?.mobile || '-' }}</td>
              </tr>
              <tr>
                <td class="label">当前等级：</td>
                <td class="value">
                  <a-tag :color="getMemberLevelColor(getLevelName(memberData?.levelId))">
                    {{ getLevelName(memberData?.levelId) }}
                  </a-tag>
                </td>
              </tr>
            </table>
          </a-card>

          <!-- 选择会员等级 -->
          <a-card
            :bordered="false"
            title="选择会员等级"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '36px', 'border-bottom': '1px solid #DDD', 'line-height': '36px', 'padding-left': '12px' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
          >
              <a-radio-group v-model="selectedLevelId" name="memberLevel" style="width: 100%">
                <div class="level-grid">
                  <div v-for="level in plusLevelList" :key="level.id" class="level-grid-item">
                    <div class="level-option" @click="selectedLevelId = level.id">
                      <a-radio :value="level.id" class="level-radio">
                        <div class="level-info">
                          <span class="level-name">{{ level.levelName }}</span>
                          <span class="level-price">¥{{ Number(level.price || 0).toFixed(2) }}</span>
                        </div>
                      </a-radio>
                    </div>
                  </div>
                </div>
              </a-radio-group>
            <div v-if="plusLevelList.length === 0" style="text-align: center; color: #999; padding: 20px;">
              <a-icon type="inbox" style="font-size: 32px;" />
              <p style="margin-top: 10px;">暂无可购买的会员等级</p>
            </div>
          </a-card>
        </a-col>

        <!-- 右侧：支付方式和金额 -->
        <a-col :span="12">
          <!-- 支付方式 -->
          <a-card
            :bordered="false"
            title="支付方式"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '36px', 'border-bottom': '1px solid #DDD', 'line-height': '36px', 'padding-left': '12px' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
            style="margin-bottom: 12px"
          >
            <a-radio-group v-model="payType" name="paymentMethod" style="width: 100%">
              <div class="payment-grid">
                <div v-for="(item, index) in payTypes" :key="index" class="payment-grid-item">
                  <div class="payment-option" @click="payType = item.value">
                    <a-radio :value="item.value" class="payment-radio">
                      <a-icon :type="item.icon" :style="{ color: item.color, fontSize: '18px', marginRight: '6px' }" />
                      {{ item.label }}
                    </a-radio>
                  </div>
                </div>
              </div>
            </a-radio-group>
          </a-card>

          <!-- 微信付款码输入 -->
          <a-card
            v-if="payType === 2"
            :bordered="false"
            title="微信付款码"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '36px', 'border-bottom': '1px solid #DDD', 'line-height': '36px', 'padding-left': '12px' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
            style="margin-bottom: 12px"
          >
            <div style="margin-bottom: 8px; color: #666; font-size: 13px;">
              <a-icon type="scan" style="margin-right: 4px;" />
              请顾客打开微信「收付款」展示付款码，输入下方18位数字
            </div>
            <a-input
              ref="authCodeInput"
              v-model="authCode"
              placeholder="扫描或输入微信付款码（18位数字，10-19开头）"
              size="large"
              allow-clear
              style="width: 100%"
            >
              <a-icon slot="prefix" type="wechat" style="color: #09bb07;" />
            </a-input>
          </a-card>

          <!-- 支付金额 -->
          <div v-if="selectedLevelInfo" class="amount-summary">
            <div class="summary-row">
              <span>会员等级：</span>
              <span class="value">{{ selectedLevelInfo.levelName }}</span>
            </div>
            <div class="summary-row total">
              <span>支付金额：</span>
              <span class="value total-price">¥{{ buyAmount.toFixed(2) }}</span>
            </div>
          </div>

          <!-- 备注 -->
          <div style="margin-top: 12px;">
            <a-textarea
              v-model="remark"
              placeholder="请输入备注信息"
              :rows="2"
              :maxLength="200"
            />
          </div>
        </a-col>
      </a-row>

      <!-- 底部操作按钮 -->
      <div class="bottom-actions">
        <a-button type="primary" size="large" :loading="loading" @click="handleSubmit" block>
          <a-icon type="check-circle" />
          确认购买
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { pageList as listPlusLevels } from '@/api/plus/plusLevel'
import { buyMember } from '@/api/retail/member'

export default {
  name: 'BuyMemberModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    memberData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      plusLevelList: [],
      selectedLevelId: undefined,
      payType: 1,
      remark: '',
      authCode: '',
      payTypes: [
        { label: '微信支付', value: 2, icon: 'wechat', color: '#09bb07' },
        { label: '支付宝', value: 1, icon: 'alipay', color: '#1677ff' },
        { label: '现金', value: 10, icon: 'money-collect', color: '#52c41a' },
        { label: '人民币支票', value: 11, icon: 'file-text', color: '#722ed1' },
        { label: '人民币信用卡', value: 12, icon: 'credit-card', color: '#eb2f96' }
      ]
    }
  },
  computed: {
    selectedLevelInfo() {
      if (!this.selectedLevelId) return null
      return this.plusLevelList.find(level => level.id === this.selectedLevelId)
    },
    buyAmount() {
      const levelInfo = this.selectedLevelInfo
      if (!levelInfo) return 0
      const price = levelInfo.price || 0
      return Number(price)
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadPlusLevels()
      }
    },
    // 选择微信支付时自动聚焦付款码输入框
    payType(val) {
      if (val === 2) {
        setTimeout(() => {
          const el = this.$refs.authCodeInput
          if (el) {
            el.focus ? el.focus() : el.$el?.querySelector('input')?.focus()
          }
        }, 100)
      }
    }
  },
  methods: {
    // 显示全局支付蒙层
    showGlobalPayOverlay() {
      if (document.getElementById('global-pay-overlay')) return
      const overlay = document.createElement('div')
      overlay.id = 'global-pay-overlay'
      overlay.innerHTML = [
        '<div class="global-pay-content">',
        '  <div class="ant-spin ant-spin-lg ant-spin-spinning">',
        '    <span class="ant-spin-dot ant-spin-dot-spin">',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '    </span>',
        '  </div>',
        '  <p class="global-pay-text">支付中，请勿刷新页面...</p>',
        '  <p class="global-pay-hint">请提醒顾客在微信中完成支付</p>',
        '</div>'
      ].join('\n')
      document.body.appendChild(overlay)
      document.body.style.overflow = 'hidden'
    },
    // 隐藏全局支付蒙层
    hideGlobalPayOverlay() {
      const overlay = document.getElementById('global-pay-overlay')
      if (overlay) {
        document.body.removeChild(overlay)
        document.body.style.overflow = ''
      }
    },
    // 加载PLUS会员等级列表
    async loadPlusLevels() {
      try {
        const response = await listPlusLevels({
          pageNum: 1,
          pageSize: 100,
          status: 1 // 只加载启用的等级
        })
        if (response.code == 20001 && response.data) {
          this.plusLevelList = response.data.records || []
        }
      } catch (error) {
        this.$message.error('加载会员等级失败')
      }
    },
    // 获取会员等级名称
    getLevelName(levelId) {
      const levelMap = {
        1: '普通会员',
        2: '银卡会员',
        3: '金卡会员',
        4: '白金会员',
        5: '钻石会员'
      }
      return levelMap[levelId] || '普通会员'
    },
    // 获取会员等级颜色
    getMemberLevelColor(levelName) {
      const colorMap = {
        '普通会员': 'default',
        '银卡会员': '#d9d9d9',
        '金卡会员': '#faad14',
        '白金会员': '#722ed1',
        '钻石会员': '#f5222d'
      }
      return colorMap[levelName] || 'default'
    },
    // 关闭弹窗
    handleCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    // 确认购买
    async handleSubmit() {
      if (!this.selectedLevelId) {
        this.$message.warning('请选择会员等级')
        return
      }
      if (!this.memberData) {
        this.$message.warning('会员信息异常')
        return
      }

      // 验证微信付款码
      if (this.payType === 2) {
        if (!this.authCode || this.authCode.trim() === '') {
          this.$message.warning('微信支付需要输入付款码')
          return
        }
        if (!/^1[0-9]{17}$/.test(this.authCode.trim())) {
          this.$message.warning('付款码格式不正确，应为18位数字（10-19开头）')
          return
        }
      }

      this.$confirm({
        title: '确认购买',
        content: `确定要为 ${this.memberData.nickName || this.memberData.mobile} 购买 ${this.selectedLevelInfo?.levelName || ''} 会员吗？支付金额为 ¥${this.buyAmount.toFixed(2)}`,
        onOk: async () => {
          // 微信支付显示全局蒙层
          if (this.payType === 2) this.showGlobalPayOverlay()
          this.loading = true
          try {
            const orderData = {
              userId: this.memberData.id,
              levelId: this.selectedLevelId,
              payType: this.payType,
              amount: this.buyAmount,
              remark: this.remark,
              authCode: this.payType === 2 ? this.authCode.trim() : undefined
            }
            const response = await buyMember(orderData)
            if (response.code == 20001 || response.code == 200) {
              this.$message.success('购买成功')
              this.$emit('success')
              this.resetForm()
            } else {
              this.$message.error(response.msg || '购买失败')
            }
          } catch (error) {
            const errMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '购买失败，请重试'
            this.$message.error(errMsg)
          } finally {
            this.loading = false
            if (this.payType === 2) this.hideGlobalPayOverlay()
          }
        }
      })
    },
    // 重置表单
    resetForm() {
      this.selectedLevelId = undefined
      this.payType = 1
      this.remark = ''
      this.authCode = ''
    }
  }
}
</script>

<style lang="less" scoped>
.buy-member-modal-container {
  .info-table {
    width: 100%;

    tr {
      height: 32px;
    }

    .label {
      width: 90px;
      color: #666;
      font-size: 13px;
    }

    .value {
      color: #333;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .level-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .level-grid-item {
    display: flex;
  }

  .level-option {
    padding: 10px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    width: 100%;

    &:hover {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    .level-radio {
      width: 100%;
      display: block;
    }

    .level-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .level-name {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }

      .level-price {
        font-size: 15px;
        color: #f5222d;
        font-weight: bold;
      }
    }
  }

  .payment-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .payment-grid-item {
    display: flex;
  }

  .payment-option {
    padding: 10px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    width: 100%;
    display: flex;
    align-items: center;

    &:hover {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    .payment-radio {
      display: flex;
      align-items: center;
    }
  }

  .amount-summary {
    background: #f0f9ff;
    border: 1px solid #bae7ff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;

    .summary-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        font-size: 13px;
        color: #666;

        &.value {
          font-weight: 500;
          color: #333;

          &.total-price {
            font-size: 18px;
            color: #f5222d;
            font-weight: bold;
          }
        }
      }

      &.total {
        border-top: 1px solid #d9d9d9;
        padding-top: 8px;
        margin-top: 8px;
      }
    }
  }

  .bottom-actions {
    margin-top: 16px;
  }

}
</style>
